import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"icon-text\"><path d=\"M15.1 0H.9C.4 0 0 .4 0 .9v10.6c0 .5.4.9.9.9h7.9l3.4 2.6c.2.2.5 0 .5-.3v-2.3h2.5c.5 0 .9-.4.9-.9V.9c-.1-.5-.5-.9-1-.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol